export default __webpack_public_path__ + "static/media/ticket-log-logo.28f505a8.png";